import { render, staticRenderFns } from "./NoteContent.vue?vue&type=template&id=20b1b8a1&scoped=true&"
import script from "./NoteContent.vue?vue&type=script&lang=js&"
export * from "./NoteContent.vue?vue&type=script&lang=js&"
import style0 from "./NoteContent.vue?vue&type=style&index=0&id=20b1b8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1b8a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
